import clsx from 'clsx'

/** The colours a side nav item takes in each state, so an item reads the same wherever it is rendered. */
export function getSideNavItemStateClassNames(isActive: boolean) {
  return {
    // An active item does not respond to hover, so hovering the page you are already on is inert.
    containerClassName: isActive
      ? 'bg-surface-selected-subtle text-brand-500'
      : 'text-text-secondary hover:bg-surface-hover hover:text-brand-neutral-900 active:bg-surface-hover',
    iconClassName: isActive ? 'text-brand-500' : 'text-text-secondary group-hover:text-brand-neutral-900',
    labelClassName: clsx('font-rethink-sans', isActive && 'text-brand-500'),
  }
}
